// ClientDigestReport.js
// Component for the Client Digest Report

// Imports
import React from 'react';
import PropTypes from 'prop-types';
import ReportCard from './ReportCard';
import ClientSelect from './ClientSelect';
import OrderSelect from './OrderSelect';
import dateFormat from 'dateformat';

// Component Class
// Shows Client Report Card
class ClientDigestReport extends React.Component {
  // Constructor
  constructor(props) {
    super(props);
    this.state = {
      order: this.getFirstOrder(),
      order2: this.getFirstOrder(),
      clientId: this.getFirstClient(),
    }
  }

  // Checks if state is still valid after an update
  componentDidUpdate() {
    if (this.validateOrder(this.state.order) && this.validateOrder(this.state.order2)) return;
    var firstOrder = this.getFirstOrder();
    this.setState({
      order: firstOrder,
      order2: firstOrder,
      clientId: this.getFirstClient(),
    });
  }

  // Validates the given order
  validateOrder = (order) => {
    if (order === this.props.orders.current) return true;
    for (var i = 0; i < this.props.orders.archive.length; i++) {
      if (order === this.props.orders.archive[i])
        return true;
    }
    return false;
  }
  
  // Returns the filename for the downloaded report
  getFilename = () => {
    var order1 = this.state.order;
    var order2 = this.state.order2;
    var date1 = order1 && order1.dateClosed ? new Date(order1.dateClosed) : new Date();
    var date2 = order2 && order2.dateClosed ? new Date(order2.dateClosed) : new Date();
    var clientName = this.state.clientId ? this.props.clients.byId[this.state.clientId].name : "";
    clientName = clientName.replace(/\s/g,'_');
    clientName = clientName.replace('.','');

    if (date2 < date1) {
      var tmp = date1;
      date1 = date2;
      date2 = tmp;
    }
    var dateStr1 = dateFormat(date1, "yyyy.mm.dd");
    var dateStr2 = dateFormat(date2, "yyyy.mm.dd");
    if (dateStr1 !== dateStr2)
      return "Carlinhos_"+clientName+"_"+dateStr1+"_"+dateStr2+".pdf";
    return "Carlinhos_"+clientName+"_"+dateStr1+".pdf";
  }

  // Returns the processed report object
  getReport = () => {
    var allOrders = this.props.orders.archive.slice();
    allOrders.push(this.props.orders.current);

    var orders = [];
    var order1 = this.state.order;
    var order2 = this.state.order2;
    var first = true;
    for (var i = 0; i < allOrders.length; i++) {
      var order = allOrders[i];

      if (!first)
        orders.push(order);

      if (order === order1 || order === order2) {
        if (first) {
          first = false;
          orders.push(order);
          if (order === order1 && order === order2)
            break;
        }
        else
          break;
      }
    }

    return this.props.report.getConsolidatedOrderReport(this.state.clientId, orders);
  }

  // Sets the first order in the interval
  setOrder = (order) => {
    this.setState({order: order});
  }
  
  // Sets the second order in the interval
  setOrder2 = (order) => {
    this.setState({order2: order});
  }

  // Returns the first order for the given client
  getFirstOrder = (clientId) => {
    if (!clientId)
      clientId = this.getFirstClient();
    if (this.filterOrder(this.props.orders.current, clientId))
      return this.props.orders.current;
    for (var i = 0; i < this.props.orders.archive.length; i++) {
      var order = this.props.orders.archive[i];
      if (this.filterOrder(order, clientId))
        return order;
    }
    return null;
  }

  // Sets the target client
  setClient = (clientId) => {
    var newOrder = this.state.order;
    if (!newOrder || !this.filterOrder(newOrder, clientId))
      newOrder = this.getFirstOrder(clientId);
    var newOrder2 = this.state.order2;
    if (!newOrder2 || !this.filterOrder(newOrder2, clientId))
      newOrder2 = this.getFirstOrder(clientId);
      
    this.setState({
      clientId: clientId,
      order: newOrder,
      order2: newOrder2,
    });
  }
  
  // Returns the first client with orders
  getFirstClient = () => {
    for (var i = 0; i < this.props.clients.ids.length; i++) {
      var id = this.props.clients.ids[i];
      if (this.filterClient(id))
        return id;
    }
    return this.props.clients.ids[0];
  }

  // Returns whether the given client should show on list
  filterClient = (clientId) => {
    return this.hasOrders(clientId);
  }

  // Returns whether the given order from a given client should show on list
  filterOrder = (order, clientId) => {
    if (!clientId)
      clientId = this.state.clientId;
    return clientId && order.byClient[clientId];
  }

  // Returns whether the given client has any orders
  hasOrders = (clientId) => {
    if (!clientId)
      clientId = this.state.clientId;
    if (this.filterOrder(this.props.orders.current, clientId))
      return true;
    for (var i = 0; i < this.props.orders.archive.length; i++)
      if (this.filterOrder(this.props.orders.archive[i], clientId))
        return true;
    return false;
  }

  // Renders Component
  render() {
    return (
      <ReportCard
        title="Resumo Consolidado de Pedidos de Cliente"
        description="Resumo de todos os pedidos de um clientes em um determinado intervalo em um único sumário."
        getReport={this.getReport}
        getFilename={this.getFilename}
        disabled={!this.hasOrders()}
      >
      <center>
        <ClientSelect
          clients={this.props.clients}
          selected={this.state.clientId}
          setClient={this.setClient}
          filter={this.filterClient}
        />
        <br />
        <br />
        <OrderSelect
          orders={this.props.orders}
          selected={this.state.order}
          setOrder={this.setOrder}
          filter={this.filterOrder}
        />
        <br />
        <OrderSelect
          orders={this.props.orders}
          selected={this.state.order2}
          setOrder={this.setOrder2}
          filter={this.filterOrder}
        />
      </center>
      <br />
      </ReportCard>
    );
  }
}

// Required Properties
ClientDigestReport.propTypes = {
  orders: PropTypes.object.isRequired,
  clients: PropTypes.object.isRequired,
  report: PropTypes.object.isRequired,
}

// Exports
export default ClientDigestReport;


// WEBPACK FOOTER //
// ./src/components/ReportView/ClientDigestReport.js